import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

const getElapsedTimeFormmated = (timeInSeconds) => {
  let timeDiff = timeInSeconds;
  const seconds = Math.round(timeDiff % 60);

  timeDiff = Math.floor(timeDiff / 60);
  const minutes = Math.round(timeDiff % 60);

  timeDiff = Math.floor(timeDiff / 60);
  const hours = Math.round(timeDiff % 24);

  return `${hours}h ${minutes}m ${seconds}s`;
};

export const fetchPendingInvoicesToBin = (type) => {
  const invoiceType = type ? `?type=${type}` : '';
  return apiActionCreator({
    'endpoint': `/invoices/binPending${invoiceType}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_PENDING_INVOICES_TO_BIN,
      ActionTypes.FETCHED_PENDING_INVOICES_TO_BIN,
      [
        ActionTypes.FETCHED_PENDING_INVOICES_TO_BIN_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const fetchInvoiceInfo = (invoice) => apiActionCreator({
  'endpoint': `/checkProcesses/invoices/${invoice}/info`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_INVOICE_INFO,
    ActionTypes.FETCHED_INVOICE_INFO,
    [
      ActionTypes.FETCHED_INVOICE_INFO_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchInvoiceLinesCheckStatus = (invoice) => apiActionCreator({
  'endpoint': `/checkProcesses/invoices/${invoice}/linesStatus`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_INVOICE_LINES_CHECK_STATUS,
    ActionTypes.FETCHED_INVOICE_LINES_CHECK_STATUS,
    ActionTypes.FETCHED_INVOICE_LINES_CHECK_STATUS_FAILED,
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const emptyInfo = () => ({
  'type': ActionTypes.EMPTY_INFO,
});

export const fetchStorageCars = (status) => apiActionCreator({
  'endpoint': `/storageProcesses/cars?status=${status}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_STORAGE_CARS,
    {
      'type': ActionTypes.FETCHED_STORAGE_CARS,
      'payload': status,
    },
    [
      {
        'type': ActionTypes.FETCHED_STORAGE_CARS_FAILED,
        'payload': status,
      },
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const changeStorageCarStatus = (storageCar, action, data) => {
  let confirmMessage = `El coche ${storageCar} se encuentra listo para el proceso de guardado`;
  if (action === 'startStorage') {
    confirmMessage = `El coche ${storageCar} ha iniciado el proceso de almacenamiento satisfactoriamente`;
  }
  if (action === 'endStorage') {
    confirmMessage = `El coche ${storageCar} ha terminado el proceso de almacenamiento satisfactoriamente
      con un tiempo de`;
  }

  return apiActionCreator({
    'endpoint': `/storageProcesses/cars/${storageCar}?action=${action}`,
    'authenticated': true,
    'types': [
      ActionTypes.CHANGING_STORAGE_CAR_STATUS,
      [
        {
          'type': ActionTypes.CHANGED_STORAGE_CAR_STATUS,
          'payload': {storageCar, action},
        },
        (response) => MessageActions.addMessageBoxInfo(action === 'endStorage' ?
          `${confirmMessage} ${getElapsedTimeFormmated(data.elapsedTime)}` : confirmMessage
        ),
      ],
      [
        {
          'type': ActionTypes.CHANGED_STORAGE_CAR_STATUS_FAILED,
          'payload': {storageCar, action},
        },
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'contentType': 'application/json',
    'data': data,
  });
};
